import { adminRoles } from '@hb/shared'
import { useMemo } from 'react'
import { useAuth } from '../../store/auth'

export const useIsAdmin = () => {
  const role = useAuth(s => s.role)

  return useMemo(() => adminRoles.includes(role ?? 'user'), [role])
}

export const useIsSuperAdmin = () => {
  const role = useAuth(s => s.role)

  return useMemo(() => role === 'super-admin', [role])
}

export const useIsLeadAdmin = () => {
  const role = useAuth(s => s.role)

  return useMemo(() => role === 'lead-admin' || role === 'super-admin', [role])
}
